import USStates from '../utils/US-States';

export const isAvailableUSState = (state: string) => {
  const abbreviation = USStates.find(s => state === s.name)?.abbreviation;
  return AvailableUSStates.some(state => abbreviation === state);
};

/**
 * List of States where BendHealth can operate in.
 * @see https://www.notion.so/vesselpartners/State-validation-on-patient-sign-up-78b94c0458c84290b5f5096cad36e334
 */
const AvailableUSStates = [
  'AK',
  'AL',
  'AR',
  'AZ',
  'CA',
  'CO',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'HI',
  'IA',
  'ID',
  'IL',
  'IN',
  'KS',
  'KY',
  'LA',
  'MA',
  'MD',
  'ME',
  'MI',
  'MN',
  'MO',
  'MS',
  'MT',
  'NC',
  'ND',
  'NE',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NV',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VA',
  'VT',
  'WA',
  'WV',
  'WI',
  'WY',
];

export default AvailableUSStates;
